import { Col, Container, Row, media } from 'styled-bootstrap-grid';
import { Helmet } from "react-helmet";
import PageTitle from "../../../PageTitle/components/PageTitle";
import React, { Fragment } from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import PageNavigation from "../../../PageNavigation/components/PageNavigation";
import GetInTouch from "../../../GetInTouch/components/GetInTouch";
import ViewMoreLink from "../../../ViewMoreLink/components/ViewMoreLink";

const Img = styled.img`
  width: 100%;
`;
const H3 = styled.h3`
  font-weight: 400;
  font-size: 1.7rem;
  margin: 0 0 1rem;
`;
// const InfoTag = styled.p`
//   font-size: 1rem;
//   font-weight: 400;
//   text-transform: uppercase;
//   letter-spacing: 0.2rem;
//   color: #717476;
//   margin: 0 0 0.5rem;
// `;
const P = styled.p`
  color: #717476;
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 2.5rem;
`;
const StyledRow = styled(Row)`
  padding-top: 4rem;
  padding-bottom: 4rem;
`;
const StyledCol = styled(Col)`
  margin-bottom: 4rem;
  
  ${media.lg`
    margin-bottom: 0;
  `}
`;

const IndustryTagWrap = styled.div`
  margin-bottom: 4rem;
`;
const IndustryTag = styled.div`
  display: inline-block;
  padding: 0 2rem;
  border: 1px solid #d7d7d7;
  border-radius: 5px;
  margin-right: 1rem;
  height: 3rem;
  border-radius: 2rem;
  text-align: center;
  font-size: 0.8rem;
  letter-spacing: 0.2rem;
  line-height: 3rem;
  text-transform: uppercase;
`;

const ServiceList = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
  border-top: 1px solid #d7d7d7;
`;
const ServiceItem = styled.li`
  display: block;
  border-bottom: 1px solid #d7d7d7;
  padding: 1rem;
`;
const ServiceTag = styled.p`
  font-size: 1rem;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.2rem;
  color: #717476;
  margin: 0;
`;
const ServiceName = styled.p`
  color: #212529;
  font-size: 1.25rem;
  font-weight: 400;
  margin: 0;
`;

const LightWrap = styled.div`
  background: #fff;
  padding: ${({padding}) => (padding) ? padding : '4rem 0'};
`;
const TransparentWrap = styled.div`
  padding: 4rem 0;
`;
const NavCol = styled(Col)`
  font-weight: bold;
  margin-top: 1rem;
  margin-bottom: 2rem;
  text-align: center;
`;
const NavSpan = styled.span`
  font-size: 0.8rem;
  padding: 0 2rem;
  vertical-align:top;
`;

const Cbdmd = (props) => {
  return <Fragment>
    <Helmet>
      <meta name="description" content=""/>
      <title>Case Study: cbdMD | RMG</title>
      <link rel="canonical" href={'https://www.rmgmedia.com/portfolio/' + props.match.params.caseStudy}/>
    </Helmet>
    <PageTitle heading="Case Study"
               subHeading="cbdMD"
    />
    <Container fluid>
      <Row>
        <Col col={12} noGutter={true}>
          <Img src="https://storage.googleapis.com/qa-rmgmediacom-images/CaseStudy/cbd_hero.png" />
        </Col>
      </Row>
    </Container>
    <Container>
      <StyledRow>
        <StyledCol col={12} lg={6}>
          <IndustryTagWrap>
            <IndustryTag>Personal Care</IndustryTag>
            <IndustryTag>Supplements</IndustryTag>
            <IndustryTag>CBD</IndustryTag>
          </IndustryTagWrap>
          <H3>
            About cbdMD
          </H3>
          <P>
            From seed to shelf, cbdMD is a company that prides itself on quality and innovation. They partnered with RMG when they realized the technology driving their website was falling behind the techonlogy driving their production and manufacturing. After identifying the causes of their server instability, RMG helped cbdMD overhaul their entire infrastructure and modernize their code development and deployment processes. The result for cbdMD is a smoother, more secure, and more reliable online experience that delights more customers.
          </P>
        </StyledCol>
        <Col col={12} lgOffset={2} lg={4}>
          <H3>
            How We Helped
          </H3>
          <ServiceList>
            <ServiceItem>
              <ServiceTag>Creative</ServiceTag>
              <ServiceName>Mobile Responsive Design</ServiceName>
              <ServiceName>User Experience Design</ServiceName>
              <ServiceName>User Interface Design</ServiceName>
            </ServiceItem>
            <ServiceItem>
              <ServiceTag>Development</ServiceTag>
              <ServiceName>B2C & B2B Implementation</ServiceName>
              <ServiceName>Backend Development</ServiceName>
              <ServiceName>Frontend Development</ServiceName>
              <ServiceName>Software Architecture Design</ServiceName>
            </ServiceItem>
            <ServiceItem>
              <ServiceTag>Devops</ServiceTag>
              <ServiceName>Application &amp; Infrastructure Support</ServiceName>
              <ServiceName>Managed Cloud Hosting</ServiceName>
              <ServiceName>Software Development Lifecycle Management</ServiceName>
            </ServiceItem>
          </ServiceList>
        </Col>
      </StyledRow>
    </Container>
    <LightWrap>
      <Container>
        <Row>
          {/*<Col col={12} lg={6}>*/}
          {/*  <div><Img src="https://via.placeholder.com/1600x900" /></div>*/}
          {/*  <div><P>As their selection of bags and options continued to grow, Rickshaw partnered with RMG to streamline their online brand experience make it feel like it does in-store. To bring this level of customization online, RMG first replatformed Rickshaw from Magento 1 to Magento 2. During the data migration, RMG made updates to the infrastructure responsible for storing product and customer data, increasing security and functional reliability. These backend updates also allow Rickshaw to rapidly iterate on designs and store their new creations as product/option variations, greatly reducing the time-to-market for new offerings.</P></div>*/}
          {/*  <div><P>This feature immediately gave Rickshaw Bags a huge return on their investment by allowing them to remain open as an essential business and produce facemasks during the COVID-19 pandemic, increasing their pageviews and conversation rate by over 400% and their revenue by almost 500%.</P></div>*/}
          {/*  <div><Img src="https://via.placeholder.com/600x600" /></div>*/}
          {/*  <div><P>After transforming Rickshaw's core digital experience, the same treatment was applied to the rest of the business by adding new shipping methods and options, upgrading their invoice processing, and revamping their blog. Together, these changes help Rickshaw scale their business as their options continue to expand and attract new audiences through their strong content-to-commerce funnel. By working with RMG, Rickshaw Bagworks was able to bring their renowned in-store experience online and expand their reach well beyond their San Francisco storefront.</P></div>*/}
          {/*</Col>*/}
          {/*<Col col={12} lg={6}>*/}
          {/*  <div><P>At the core of Rickshaw's brand experience is the ability to customize a bag's flap, body, inner lining, bindings, buckles, labels, and straps, each of which comes in multiple colors and fabrics. Because of their extraordinary selection, Rickshaw staff's knowledgeable designers to help customers build the best bags based on their needs. In addition, Rickshaw designs and manufactures many custom fabrics, which greatly expands the audiences and applications their products cater to.</P></div>*/}
          {/*  <div><Img src="https://via.placeholder.com/800x1000" /></div>*/}
          {/*  <div><P>On the frontend, RMG built a specialized product customizer which allowed for multiple interacting filters, such as part color and fabric. This customizer also allows customers to make unique, personalized color variations which can be applied across all of Rickshaw's products. In addition, RMG redesigned Rickshaw's entire customer journey to be mobile-first, allowing customers to navigate the customization process with ease regardless of the device they use. As part of this redesign, RMG restyled most of the imagery across the site, even adding support for moving GIF images. We also streamlined Rickshaw's product, catalog, cart, and checkout pages to minimize friction and provide better responsiveness.</P></div>*/}
          {/*  <div><Img src="https://via.placeholder.com/1600x900" /></div>*/}
          {/*</Col>*/}
          <Col col={12} lg={6}>
            <Img src="https://storage.googleapis.com/qa-rmgmediacom-images/CaseStudy/cbd_img_01.png" />
          </Col>
          <Col col={12} lg={6}>
            <P>cbdMD has made a name for itself in the hemp-based cannabidiol market by combining the highest quality CBD with state-of-the-art production techniques. They proudly source their hemp and manufacture their CBD in the USA, minimizing the impacts of storage and domestic transportation of their hemp-based products. From farm to bottle, cbdMD uses advanced technology to closely monitor and test their batches at every step of the production process, ensuring their brand name is always tied to quality.</P>
          </Col>
        </Row>
      </Container>
    </LightWrap>
    <TransparentWrap>
      <Container>
        <Row>
          <Col col={12} lg={6}>
            <P>cbdMD partnered with RMG when they realized their online brand experience wasn't reflecting that commitment to quality. The increasing demand for their product was causing instability in their infrastructure and their development and deployment processes prevented them from addressing these issues in a timely manner, affecting their bottom line. On the frontend, they wanted to transform their site from a single store to a multi-store experience and add features to help their customers more conveniently find and order the right products for them.</P>
            <P>RMG migrated cbdMD to an infrastructure-as-code model where servers can be rebuilt and redeployed at any time with minimal effort. RMG leveraged an open source, state-of-the-art tool called Conductor to remove human error from the deployment process, lowering downtime and improving the frontend experience. By leveraging our partnership with Cloudflare, RMG also beefed up cbdMD's infrastructure security by helping them manage their SSL certificates, maintain robust firewalls, and increase protections against bots and DDOS attacks.</P>
          </Col>
          <Col col={12} lg={6}>
            <Img src="https://storage.googleapis.com/qa-rmgmediacom-images/CaseStudy/cbd_img_02.png" />
          </Col>
        </Row>
      </Container>
    </TransparentWrap>
    <LightWrap>
      <Container>
        <Row>
          <Col col={12} lg={6}>
            <Img src="https://storage.googleapis.com/qa-rmgmediacom-images/CaseStudy/cbd_img_03.png" />
          </Col>
          <Col col={12} lg={6}>
            <P>RMG standardized and automated cbdMD's agile workflow, code organization, testing plans, and change management processes to improve the cadence and reliability of code deployments while reducing the amount of manual work involved.</P>
            <P>RMG redesigned and customized pages to be useful across their other brands, helping cbdMD transition from a single online store to a multi-brand experience. RMG developed quick-find and quick-order features to minimize friction and shorten the average length of their customer journeys, resulting in more conversions and happy customers. A custom payment gateway, Green Money, was also built to bring disparate payment methods together into a cohesive checkout experience.</P>
            <P>RMG's partnership with cbdMD is about more than modernizing infrastructure and implementing features across their multiple brands. Through automation, documentation, video guides, and trainings, RMG helped cbdMD learn to manage critical parts of their own infrastructure, allowing them to internally troubleshoot issues as they arise and allocate more dollars to innovating. As a result, cbdMD can keep raising the bar of their brand experience, translating into more new and returning customers.</P>
          </Col>
        </Row>
      </Container>
    </LightWrap>
    <LightWrap padding="0">
      <Container>
        <Row>
          <NavCol col={12}>
            <ViewMoreLink textColor="#000" arrowWidth='0.6rem' directionReversed
                          to={`/portfolio/anova-furnishings`}
                          buttonText="Anova Furnishings" />
            <NavSpan>/</NavSpan>
            <ViewMoreLink textColor="#000" arrowWidth='0.6rem' to={`/portfolio/rickshaw-bagworks`}
                          buttonText="Rickshaw Bagworks" />
          </NavCol>
        </Row>
      </Container>
    </LightWrap>
    <GetInTouch title="Get In Touch"
                text="You could be our next case study."
                buttonText="Let's talk"
                useArrow
    />
    <PageNavigation prev="capabilities" next="insights" />
  </Fragment>;
};

export default withRouter(Cbdmd);